import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";

const ExecutionEntryOnGoingEstablishmentChoice = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
        manualEntryProps={{
          showProposalDiagnostic: true,
        }}
      />
    </>
  );
}

export default ExecutionEntryOnGoingEstablishmentChoice;
